import dynamic from 'next/dynamic';
import { useParams } from 'next/navigation';

const StaticPageContainer = dynamic(
  () => import('../common/StaticPageContainer')
);
const AboutUs = dynamic(() => import('./AboutUs'));
const Kvkk = dynamic(() => import('./Documents/Kvkk'));
const Cookies = dynamic(() => import('./Documents/Cookies'));

const Agencies = dynamic(() => import('./Agencies'));
const SeturPublications = dynamic(() => import('./SeturPublications'));

const CorporatePagesSwitch = () => {
  const params = useParams();
  const { slug = '' } = params as Record<string, string>;

  let StaticPageComponent: React.ElementType;
  switch (slug) {
    case 'hakkimizda':
      StaticPageComponent = AboutUs;
      break;
    case 'acentelerimiz':
      StaticPageComponent = Agencies;
      break;
    case 'setur-yayinlari':
      StaticPageComponent = SeturPublications;
      break;
    case 'kvkk':
      StaticPageComponent = Kvkk;
      break;
    case 'cerez-politikasi':
      StaticPageComponent = Cookies;
      break;
    default:
      StaticPageComponent = StaticPageContainer;
      break;
  }

  return <StaticPageComponent />;
};

export default CorporatePagesSwitch;
